"use strict";
// Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var MediaRecordingEvent;
(function (MediaRecordingEvent) {
    MediaRecordingEvent["EndedEvent"] = "ended";
})(MediaRecordingEvent = exports.MediaRecordingEvent || (exports.MediaRecordingEvent = {}));
exports.default = MediaRecordingEvent;
//# sourceMappingURL=MediaRecordingEvent.js.map